import React from 'react'
import { Flex } from '@chakra-ui/react'

const Main = props => (
  <Flex
    as="main"
    flexDirection="column"
    height="full"
    width="full"
    flexWrap="nowrap"
  >
    {props.children}
  </Flex>
)

Main.defaultProps = {
  display: 'flex',
}

export default Main
